import { JSX, StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ConfigurationService } from '../../../services/configuration.service';
import LoggedOff from '../LoggedOff';
import Teacher from '.';
import RegisterInCompetition from '../Shared/RegisterInCompetition';
import RegisterScore from '../Shared/RegisterScore';
import Participation from './components/Participation';
import EditParticipation from '../Shared/EditParticipation';
import AccessDenied from '../AccessDenied';
import AddTeacher from '../Shared/AddTeacher';
import { Role } from '../../../models/pa-egna-ben/role.enum';
import MyInformation from '../Shared/MyInformation';
import DeleteAccount from '../Shared/DeleteAccount';
import NotFoundRedirect from '../Shared/NotFoundRedirect';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Teacher />,
    },
    {
      path: '/klasser/:participationId/klassuppgifter',
      element: <EditParticipation viewerRole={Role.teacher} />,
    },
    {
      path: '/klasser/:participationId/lagg-till-pedagog',
      element: <AddTeacher viewerRole={Role.teacher} />,
    },
    {
      path: '/klasser/:participationId/etapp/:legNumber/rapportera-poang',
      element: <RegisterScore />,
    },
    {
      path: '/klasser/:participationId',
      element: <Participation />,
    },
    {
      path: '/anmalning',
      element: <RegisterInCompetition role={Role.teacher} />,
    },
    {
      path: '/mina-uppgifter',
      element: <MyInformation viewerRole={Role.teacher} />,
    },
    {
      path: '/avsluta-konto',
      element: <DeleteAccount role={Role.teacher} />,
    },
    {
      path: '/session-utgangen',
      element: (
        <LoggedOff
          headingText="Du har blivit utloggad"
          bodyText="För att skydda dina uppgifter loggas du automatiskt ut efter en tids inaktivitet. Logga in igen för att fortsätta använda tjänsten."
        />
      ),
    },
    {
      path: '/atkomst-saknas',
      element: <AccessDenied />,
    },
    {
      path: '*',
      element: <NotFoundRedirect />,
    },
  ],
  { basename: ConfigurationService.get('paegnaben.teacherpage.basename') }
);

export default function createRouterProvider(): JSX.Element {
  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
